import React from "react";

export default function ApplicationSectionHeader({
  title,
  description,
}: {
  title: string;
  description: string | React.ReactNode;
}) {
  return (
    <div className="relative flex w-full flex-col items-start justify-start gap-[3px] text-left text-[14px]/[21px]">
      <div className="text-color-button-primary text-sm font-semibold uppercase">
        {title}
      </div>
      <div className="text-color-text-secondary text-xl/[25px] font-normal">
        {description}
      </div>
    </div>
  );
}
